import { useQuery, useMutation } from "@apollo/client/react"; import React, { useEffect, useState } from 'react';
import {
  Grid
} from
  '@mui/material';
import { SwitchInput } from '../../../components/switchInput/SwitchInput';
import { TextInput } from '../../../components/textInput/TextInput';
import { SelectInput } from '../../../components/selectInput/SelectInput';

import { GET_PROGRAM_TYPES } from '../../../data/graphQL/queries/programaAsistencia/getProgramTypes';
import { AutocompleteInput } from '../../../components/autocompleteInput/AutocompleteInput';

import { CREATE_PROGRAM_SUBTYPE } from '../../../data/graphQL/mutations/programaAsistencia/createProgramSubtype';
import { CREATE_ASSISTANCE_PROGRAM } from '../../../data/graphQL/mutations/programaAsistencia/createProgram';
import { useNavigate, useLocation } from 'react-router-dom';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { EDIT_ASSISTANCE_PROGRAM } from '../../../data/graphQL/mutations/programaAsistencia/editProgram';

import './assistanceProgramCreation.scss';
export const AssistanceProgramCreationContent = ({ setChildrenAction }) => {
  const { data: programTypesData } = useQuery(GET_PROGRAM_TYPES);
  const navigate = useNavigate();
  const location = useLocation();
  const editProgramData = location.state;
  const [creationData, setCreationData] = useState({
    type: editProgramData?.programTypeId || undefined,
    subType: editProgramData?.subtypeId || undefined,
    name: editProgramData?.name || '',
    active: editProgramData?.active || false
  });
  const isNew = Boolean(!editProgramData);

  const [createProgramSubtype, { error, data }] = useMutation(CREATE_PROGRAM_SUBTYPE, {
    onCompleted: (responseData) => {
      setCreationData((previousData) => ({
        ...previousData,
        subType: responseData?.createSubtypeProgram?.idSubTipoPrograma
      }));
    },
    refetchQueries: [
      GET_PROGRAM_TYPES]

  });

  const [createProgram, { error: createProgramError }] = useMutation(CREATE_ASSISTANCE_PROGRAM, {
    onCompleted: () => {
      navigate('/programas');
    }
  });
  const [editProgram, { error: editProgramError }] = useMutation(EDIT_ASSISTANCE_PROGRAM, {
    onCompleted: () => {
      navigate('/programas');
    }
  });

  useEffect(() => {
    setChildrenAction(() =>
      <CustomButton
        disabled={!creationData?.type || !creationData?.subType || !creationData?.name?.length}
        onClick={() => {
          if (isNew) {
            createProgram({
              variables: {
                name: creationData?.name,
                idProgramSubtype: creationData?.subType,
                active: creationData?.active
              }
            });
          } else {
            editProgram({
              variables: {
                idProgram: editProgramData?.programId,
                name: creationData?.name,
                idProgramSubtype: creationData?.subType,
                active: creationData?.active
              }
            });
          }
        }}>

        {isNew ? 'Nuevo' : 'Guardar'}
      </CustomButton>
    );
  }, [setChildrenAction, creationData]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setCreationData((data) => ({ ...data, [name]: value }));
  };

  const handleChangeAutocomplete = (value, name) => setCreationData((data) => ({ ...data, [name]: value }));

  const programTypes = programTypesData?.programTypes?.map((type) => ({ ...type, id: type.idTipoPrograma, displayName: type.nombre }));
  const selectedProgramSubtypes = programTypes?.
    find((type) => type.idTipoPrograma === creationData?.type)?.subTipoPrograma?.
    map((subType) => ({ id: subType.idSubTipoPrograma, displayName: subType.nombre }));

  return (
    <div className='assistance-program-creation'>
      <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 8
        }}
        rowGap={4}>

        <Grid size={{ xs: 2 }}>
          <SelectInput
            options={programTypes}
            label='Tipo'
            onChange={handleChange}
            value={creationData.type}
            name='type'
            placeholder='hola' />

        </Grid>
        <Grid size={{ xs: 2 }}>
          <AutocompleteInput
            key={selectedProgramSubtypes}
            options={selectedProgramSubtypes}
            disabled={!creationData.type}
            label='Subtipo'
            onOptionCreation={(newValue) => createProgramSubtype({ variables: { name: newValue, idProgramType: creationData?.type } })}
            name='subType'
            onChange={handleChangeAutocomplete}
            value={selectedProgramSubtypes?.find((subtype) => subtype.id === creationData?.subType) || ''} />

        </Grid>
        <Grid size={{ xs: 2 }}>
          <TextInput
            onChange={handleChange}
            label='Programa'
            placeholder='Ingresa un nombre para el programa'
            value={creationData?.name}
            name='name' />

        </Grid>
        <Grid size={{ xs: 1 }}>
          <div className='switch-row'>
            <span>Activo</span>
            <SwitchInput
              onChange={(e) => setCreationData((data) => ({ ...data, active: e.target.checked }))}
              checked={creationData?.active}
              name={'active'} />

          </div>
        </Grid>
      </Grid>
    </div>);

};